const { getElement } = window.BAO.Utils

export class SiteDrawer extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.secondaryHeader = getElement(
      '[data-site-drawer-el="secondary-header"]',
      { context: this },
    )

    this.drawers = getElement('site-drawers')
    if (!this.drawers) {
      throw new Error(
        `${this.nodeName.toLowerCase()} needs a <site-drawers> element to work`,
      )
    }
    this.drawers.drawers.push(this)

    this._isOpen = false
    this.timeout = null
  }

  setupListeners () {
    super.setupListeners()

    if (this.secondaryHeader !== null) {
      this.listeners.add(this, 'drawer:showSecondaryHeader', (event) => {
        const message = event.detail?.data?.message

        if (typeof message !== 'undefined') {
          this.showSecondaryHeader(message)
        }
      })

      this.listeners.add(
        this,
        'drawer:hideSecondaryHeader',
        this.hideSecondaryHeader.bind(this),
      )

      this.listeners.add(this, 'transitionend', () => {
        if (this._isOpen === false) {
          this.hideSecondaryHeader()
        }
      })
    }
  }

  connectedCallback () {
    super.connectedCallback()

    if (this.drawerShouldBeMoved) {
      window.setTimeout(
        () => {
          const moveToElement = this.moveToElement

          this.removeAttribute('data-module-drawers-move-me')

          moveToElement.appendChild(this)
        },
        parseInt(this.getAttribute('data-module-drawers-move-delay'), 10) || 0,
      )
    }
  }

  showSecondaryHeader (message) {
    if (
      this.secondaryHeader == null ||
      typeof message === 'undefined' ||
      message.length === 0
    ) {
      return
    }

    clearTimeout(this.timeout)

    let index = 0

    this.secondaryHeader.textContent = ''
    this.secondaryHeader.classList.add('drw-Drawer_SecondaryHeader-active')

    this.timeout = setTimeout(() => {
      const interval = setInterval(() => {
        this.secondaryHeader.textContent +=
          typeof message[index] !== 'undefined' ? message[index] : ''

        index++

        if (index >= message.length) {
          clearInterval(interval)
        }
      }, 1600 / message.length)
    }, 800)
  }

  hideSecondaryHeader () {
    if (this.secondaryHeader !== null) {
      this.secondaryHeader.textContent = ''
      this.secondaryHeader.classList.remove(
        'drw-Drawer_SecondaryHeader-active',
      )
    }
  }

  get key () {
    return this.getAttribute('key')
  }

  get elements () {
    return {
      trigger: getElement(`[data-drawers-trigger=${this.key}]`),
      close: getElement(`[data-module-drawers-close=${this.key}]`),
    }
  }

  get isOpen () {
    return this._isOpen
  }

  set isOpen (val) {
    this._isOpen = val

    this.classList.toggle(this.config.classes.activeDrawerClass, val)
  }

  get drawerShouldBeMoved () {
    return this.hasAttribute('data-module-drawers-move-me')
  }

  get moveToElement () {
    switch (this.getAttribute('data-module-drawers-move-me')) {
      case 'root':
        return this.drawers
      default:
        return getElement(this.getAttribute('data-module-drawers-move-me'))
    }
  }

  get config () {
    return {
      classes: {
        activeDrawerClass: 'drw-Drawer-active',
      },
    }
  }
}

customElements.define('site-drawer', SiteDrawer)
